export default __webpack_public_path__ + "static/professional-training-banner-2-079f7308fa60cce7a8a5f42787baf2aa.png";